module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Medium.407480e.woff2";